
/**
 * 车辆审核时信息修改
 */
import React, { Component } from 'react';
import { Modal, Form, Input, Row, Col, Switch, Divider, InputNumber, DatePicker, Select } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import validator from '../../../util/validator';
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';
import MemberSelect from '../../crm/member/MemberSelect';
import '../../../style/common/uploadImage.css';

const vehicleField = [{
    "text": "商户",
    "field": "memberCode",
    "strField": "memberName",
    "disabled":true,
    "member":true,
    rules: [
        { required: true, message: '商户不能为空!' }
    ],
}, {
    "text": "车架号",
    "field": "vin",
    rules: [
        { required: true, message: '车架号不能为空!' },
        { max: 32, message: '车架号不能超过32个字符！' },
        validator.enNum
    ]
}, {
    "text": "车牌号",
    "field": "plateNo",
    rules: [
        { required: true, message: '车牌号码不能为空!' },
        validator.plateNo
    ]
}, {
    "text": "初登日期",
    "field": "registerDate",
    "date": true,
}, {
    "text": "品牌型号",
    "field": "brandModel",
    rules: [
        { required: true, message: '品牌型号不能为空!' },
        { max: 64, message: '品牌型号不能超过64个字符！' },
    ]
}, {
    "text": "使用性质",
    "field": "useProperty",
    "select": true,
    "category": "VEHICLE_USE_PROPERTY",
    rules: [
        { required: true, message: '使用性质不能为空!' },
    ]
}, {
    "text": "车主姓名",
    "field": "owner",
    rules: [
        { required: true, message: '车主名称不能为空!' },
        { max: 32, message: '车主名称不能超过32个字符！' },
    ]
}, {
    "text": "车主住所",
    "field": "ownerAddress",
    "textarea": true,
    rules: [
        { required: true, message: '车主住所不能为空!' },
        { max: 128, message: '车主住所不能超过128个字符！' },
    ]
}];

const otherField = [{
    "text": "车辆类型",
    "field": "carType",
    "carTypeStr": true
}, {
    "text": "表显里程/万公里",
    "field": "mileage",
    "number": true,
    "precision": 2,
    rules: [
        { required: true, message: '表显里程不能为空!' },
    ]
}, {
    "text": "商城标价/万元",
    "field": "price",
    "disabled": true
}, {
    "text": "品牌车型",
    "field": "name",
    "disabled": true
    // rules: [
    //     { required: true, message: '品牌车型不能为空!' },
    //     { max: 64, message: '品牌车型不能超过64个字符！' },
    // ]
}, {
    "text": "车身颜色",
    "field": "color",
    "select": true,
    "category": "VEHICLE_COLOR",
    rules: [
        { required: true, message: '车身颜色不能为空!' },
    ]
}, {
    "text": "车辆所属地",
    "field": "location",
    rules: [
        { required: true, message: '车辆所属地不能为空!' },
    ]
}, {
    "text": "过户次数",
    "field": "transferTimes",
    "number": true,
    "precision": 0,
    rules: [
        { required: true, message: '过户次数不能为空!' },
    ]
}, {
    "text": "出厂日期",
    "field": "productionDate",
    "date": true,
}, {
    "text": "年检到期日期",
    "field": "examinationDate",
    "date": true,
}, {
    "text": "交强险到期日期",
    "field": "mandatoryInsuranceDate",
    "date": true,
}, {
    "text": "商业险到期日期",
    "field": "commerciaInsuranceDate",
    "date": true,
}, {
    "text": "钥匙数量",
    "field": "keyNum",
    "number": true,
    "precision": 0,
}, {
    "text": "车况描述对外可见",
    "field": "remarkVisible",
    "radio": true,
}, {
    "text": "车况描述",
    "field": "mark",
    "textarea": true,
    rules: [
        { max: 256, message: '车况描述不能超过256个字符！' },
    ]
}, {
    "text": "配置亮点描述",
    "field": "detailHighlight",
    "textarea": true,
    rules: [
        { max: 256, message: '配置亮点描述不能超过256个字符！' },
    ]
}];

class VehicleAuditEditForm extends Component {

    state = {
        loadingVisible: false,
        dictText: {},
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ loadingVisible: true });

            values["id"] = this.props.editData["id"];

            if (values["registerDate"] != null) {
                values["registerDate"] = values["registerDate"].format("YYYY-MM-DD");
            }

            if (values["productionDate"] != null) {
                values["productionDate"] = values["productionDate"].format("YYYY-MM-DD");
            }

            if (values["examinationDate"] != null) {
                values["examinationDate"] = values["examinationDate"].format("YYYY-MM-DD");
            }

            if (values["mandatoryInsuranceDate"] != null) {
                values["mandatoryInsuranceDate"] = values["mandatoryInsuranceDate"].format("YYYY-MM-DD");
            }

            if (values["commerciaInsuranceDate"] != null) {
                values["commerciaInsuranceDate"] = values["commerciaInsuranceDate"].format("YYYY-MM-DD");
            }
            values["remarkVisible"] = values["remarkVisible"] ? 1 : 0;
           
            http.post({
                url: '/vehicleAudit/updateVehicleInfo',
                data: values,
                success: (res) => {
                    let editData = this.props.editData;
                    let fields = vehicleField.concat(otherField);
                    for(let i in fields){
                        editData[fields[i]["field"]] = values[fields[i]["field"]];
                        if(fields[i]["select"]){
                            let dictText = this.state.dictText[fields[i]["field"]];
                            if(dictText != null){
                                editData[fields[i]["field"]+"Str"] = dictText;
                            }
                        }else if(fields[i]["member"] && this.props.editData.status==='DRAFT'){
                            let dictText = this.state.dictText[fields[i]["strField"]];
                            if(dictText != null){
                                editData[fields[i]["strField"]] = dictText;
                            }
                        }
                    }
                    editData["carTypeStr"] = values["carType"] === 1 || values["carType"] === "1" ? '新车' : '二手车';
                    this.props.onCancel();
                    messager.notify("保存成功！");
                    this.props.successCallback();
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    };

    transferData = (res, field) => {
        let value = res[field];
        for (let key in value) {
            res[field + "." + key] = value[key];
        }
        delete res[field];
    }
     //字典选择改变时触发
   

    createDom = (item, index, colLength) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let labelCol = colLength === 1 ? 10 : 4;
        let wrapperCol = colLength === 1 ? 14 : 20;
        let field = item.field;
        if(editData.status==='VERIFYING' && field === "memberCode" ){
            field = item["strField"];
        }
        let itemDom = (
            <Form.Item key={index} label={item.text + "："} labelCol={{ span: labelCol }} wrapperCol={{ span: wrapperCol }}>
                {
                    getFieldDecorator(field, {
                        rules: item.rules,
                        initialValue: item.date ? (editData[field] == null || editData[field] === "" ? null : moment(editData[field]))
                            : item.radio ? editData[field] === 1
                                : editData[field],
                        valuePropName: item.radio ? 'checked' : 'value'
                    })(
                        item.number ?
                            <InputNumber precision={item.precision} min={0} max={99999999} style={{ width: '100%' }} />
                            : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" />
                                : item.select ?
                                    <DictSelect category={item.category} onSelect={this.onSelect.bind(this, field)} />
                                    : item.carTypeStr ?
                                        <Select>
                                            <Select.Option key={0}>二手车</Select.Option>
                                            <Select.Option key={1}>新车</Select.Option>
                                        </Select>
                                        : item.date ? <DatePicker style={{ width: '100%' }} />
                                            : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                            : item.member&&editData.status==='DRAFT' ? <MemberSelect mall={1} onSelect={this.onSelect.bind(this, item["strField"])} />
                                                : <Input disabled={item.disabled} />
                                                
                    )
                }
            </Form.Item>
        );
        return itemDom;
    };

    create2Col = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>
                    {this.createDom(data[i], "1" + i, 1)}
                </Col>
                <Col span={11} offset={2}>
                    {(i + 1) < data.length ? this.createDom(data[i + 1], "1" + i, 1) : ''}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    }

    create1Col = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = this.createDom(data[i], "2" + i, 2);
            dom.push(item);
        }
        return dom;
    }

    onSelect = (field, dict) => {
        let dictText = this.state.dictText;
        dictText[field] = dict["name"];
        this.setState({ dictText: dictText });
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="车辆信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.props.form.resetFields();
                    this.setState({ dictText: {} })
                }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Divider orientation="left">基本信息</Divider>
                    {this.create2Col(vehicleField)}
                    <Divider orientation="left">其他信息</Divider>
                    {this.create2Col(otherField)}
                </Form>
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
            </Modal>
        );
    }
}

const VehicleAuditEdit = Form.create()(VehicleAuditEditForm);

export default VehicleAuditEdit;